import { Alert, AlertDescription, AlertIcon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const AnonymizationBanner = () => {
  const { t } = useTranslation();
  return (
    <Alert status="warning" rounded="md" fontSize="sm" alignItems="flex-start">
      <AlertIcon />
      <AlertDescription>
        {t(
          "Equal treatment: anonymize the supplier and remove identifying details before publishing to all tenderers."
        )}
      </AlertDescription>
    </Alert>
  );
};
